'use strict';

window.skrollr = require('skrollr/src/skrollr');

MPP.ImageParallax = class ImageParallax {
  constructor({ el, pixelsToScroll }) {
    this.el = el;
    this.pixelsToScroll = pixelsToScroll;
    this.$el = $(this.el); // do not use parallax on mobile

    if (!($(window).width() >= 768)) {
      return;
    } // do not initialize skrollr if the viewport is too small and there's no hero image

    const background = this.$el.css('background-image');

    if (background == null || background === 'none') {
      return;
    }

    this.parallaxHandler = window.skrollr.init({
      mobileCheck() {
        return false;
      },

      // disable mobile scrolling hacks that slow down the page on mobile phones
      forceHeight: false,
    }); // this disables setting the body height because it was causing issues (which means the image won't scroll if the page is not long enough)

    this.refresh();
    $(window).resize(() => this.refresh());
  }

  refresh() {
    if (!(this.$el != null ? this.$el.length : undefined)) {
      return;
    }

    this.setImageSize();
  }

  setStopsBasedOnHeight(height, initialVerticalPosition) {
    const heightOfHeroImageAndHeader =
      this.$el.height() + this.$el.offset().top;
    this.$el.attr(
      'data-0',
      `background-position: center ${initialVerticalPosition}px;`
    );
    this.$el.attr(
      `data-${heightOfHeroImageAndHeader}`,
      `background-position: center ${initialVerticalPosition -
        this.pixelsToScroll}px;`
    );
    return this.parallaxHandler.refresh();
  }

  setImageSize() {
    let imageUrl = this.$el.css('background-image'); // remove url() or url("")

    imageUrl =
      imageUrl.match(/^url\("?(.+?)"?\)$/) &&
      imageUrl.match(/^url\("?(.+?)"?\)$/)[1];

    if (!imageUrl) {
      return null;
    }

    const img = new Image();
    $(img).load(() => {
      // First, we try to set the height to the minimum possible (the height of the hero image space + space for scrolling)
      // and we scale the width to match this new height.
      let height = this.$el.height() + this.pixelsToScroll * 2;
      let width = Math.ceil((height * img.width) / img.height);
      let initialVerticalPosition = 0;

      if (width < this.$el.width()) {
        // If the image width doesn't fill the whole page with this new dimensions, then we try to do it the other way around:
        // We set the width to fill the whole page and scale the height to match this new width.
        width = this.$el.width();
        height = Math.ceil((width * img.height) / img.width); // Then we center the image.

        initialVerticalPosition =
          -1 * Math.floor((height - this.$el.height()) / 2);
      }

      this.$el.css('background-size', `${width}px ${height}px`);
      this.$el.css(
        'background-position',
        `center ${initialVerticalPosition}px`
      );
      return this.setStopsBasedOnHeight(height, initialVerticalPosition);
    });
    img.src = imageUrl;
    return img.src;
  }
};
$(() => {
  const el = '.merchant-header > .merchant-hero-image';

  if (!($(el).length > 0)) {
    return null;
  }

  const headerConfig = $(el).data();
  return new MPP.ImageParallax({
    el,
    pixelsToScroll: headerConfig.pixelsToScroll,
  });
});
